import React, { useState } from 'react';
import PdfViewer from '../components/Pdf/PdfViewer';
import { useFloorPlan } from '../hooks/useFloorPlan';
import { Empty } from 'antd';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

export const FloorPlan = () => {
    const { FloorPlan, isLoading, error } = useFloorPlan();
    const { pageHeader, isLoading: headerLoading } = usePageHeaderByKey("floor-plan");
    const [activeIndex, setActiveIndex] = useState(null);

    if (isLoading || headerLoading) return <div className="flex h-screen justify-center items-center"><i className="pi pi-spin pi-spinner text-red-700" style={{ fontSize: '2rem' }}></i></div>;
    if (error) return <div>Error: {error.message}</div>;

    const getFileExtension = (url) => {
        if (typeof url !== 'string') return null; 
        const cleanUrl = url.split('?')[0];
        return cleanUrl.split('.').pop().toLowerCase();
    };

    return (
        <PublicPageShell>
            <div className="flex flex-col justify-center w-full">
                {pageHeader?.h1 && (
                    <h1 className="text-2xl mb-4 text-left font-bold text-black uppercase">
                        {pageHeader.h1}
                    </h1>
                )}
                {pageHeader?.tagline && (
                    <p className="mb-4 text-gray-700 md:text-sm leading-relaxed">
                        {pageHeader.tagline}
                    </p>
                )}
                {pageHeader?.content && (
                    <div 
                        className="mb-4 text-gray-700 leading-relaxed md:text-sm"
                        dangerouslySetInnerHTML={{ __html: pageHeader.content }}
                    />
                )}
            </div>
        <div className="card min-h-screen w-full">
            {FloorPlan && FloorPlan.length > 0 ? (
                <Accordion 
                    activeIndex={activeIndex} 
                    onTabChange={(e) => setActiveIndex(e.index)}
                    className="custom-tabview"
                >
                    {FloorPlan.map((doc, index) => (
                        <AccordionTab 
                            header={doc.title} 
                            key={index} 
                            headerClassName={`text-[#003049] uppercase ${activeIndex === index ? "active-tab" : ""}`}
                        >
                            {Array.isArray(doc.floorUrls) ? (
                                doc.floorUrls.map((fileUrl, idx) => {
                                    const fileExtension = getFileExtension(fileUrl.url);

                                    return (
                                        <div key={idx} className="mb-4">
                                            {fileExtension === 'pdf' ? (
                                                <PdfViewer pdfUrl={fileUrl.url} />
                                            ) : ['jpeg', 'jpg', 'png', 'gif', 'webp'].includes(fileExtension) ? (
                                                <img src={fileUrl.url} alt={`Floor plan ${idx + 1}`} className="w-full" />
                                            ) : (
                                                <div>Unsupported file type</div>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div><Empty /></div>
                            )}
                        </AccordionTab>
                    ))}
                </Accordion>
            ) : (
                <div className="w-full min-h-screen flex justify-center items-center">
                    <Empty />
                </div>
            )}
        </div>
        </PublicPageShell>
    );
};
